import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { Dictionary } from '../../base/dictionary';
import { WBorders } from './borders';
import { WUniqueFormat } from '../../base/unique-format';
import { WUniqueFormats } from '../../base/unique-formats';
import { WListFormat } from './list-format';
import { ParagraphWidget, TableCellWidget, BlockContainer, TextFrame } from '../viewer/page';
import { WParagraphStyle } from './style';
/* eslint-disable */
/**
 * @private
 */
export class WTabStop {
    get position() {
        return this.positionIn;
    }
    set position(value) {
        this.positionIn = value;
    }
    get deletePosition() {
        return this.deletePositionIn;
    }
    set deletePosition(value) {
        this.deletePositionIn = value;
    }
    get tabJustification() {
        return this.justification;
    }
    set tabJustification(value) {
        this.justification = value;
    }
    get tabLeader() {
        return this.leader;
    }
    set tabLeader(value) {
        this.leader = value;
    }
    clone() {
        let tabStop = new WTabStop();
        tabStop.deletePosition = this.deletePosition;
        tabStop.position = this.position;
        tabStop.tabJustification = this.tabJustification;
        tabStop.tabLeader = this.tabLeader;
        return tabStop;
    }
    equals(tab) {
        if (this.position === tab.position &&
            this.deletePosition === tab.deletePosition &&
            this.tabJustification === tab.tabJustification &&
            this.tabLeader === tab.tabLeader) {
            return true;
        }
        else {
            return false;
        }
    }
    destroy() {
        this.position = undefined;
        this.deletePosition = undefined;
        this.tabJustification = undefined;
        this.leader = undefined;
    }
}
/**
 * @private
 */
export class WParagraphFormat {
    constructor(node) {
        this.uniqueParagraphFormat = undefined;
        this.ownerBase = undefined;
        this.baseStyle = undefined;
        this.tabs = undefined;
        this.ownerBase = node;
        this.listFormat = new WListFormat(this);
        this.borders = new WBorders(this);
        this.tabs = [];
    }
    getUpdatedTabs() {
        let inTabs = [];
        const tabStops = new Dictionary();
        let tabsInListFormat = this.getTabStopsFromListFormat();
        for (const tabStop of tabsInListFormat) {
            if (!tabStops.containsKey(tabStop.position)) {
                tabStops.add(tabStop.position, tabStop);
            }
        }
        if (!isNullOrUndefined(this.baseStyle) && this.baseStyle instanceof WParagraphStyle) {
            let baseStyle = this.baseStyle;
            while (!isNullOrUndefined(baseStyle)) {
                for (const tab of baseStyle.paragraphFormat.tabs) {
                    if (!tabStops.containsKey(tab.position)) {
                        tabStops.add(tab.position, tab);
                    }
                }
                baseStyle = baseStyle.basedOn;
            }
            let tabsCollection = [];
            tabStops.keys.forEach((key) => { tabsCollection.push(tabStops.get(key)); });
            for (let i = 0; i < tabsCollection.length; i++) {
                let tabStop = tabsCollection[i];
                if (!this.isValidTabStop(tabsCollection, tabStop)) {
                    tabStops.remove(tabStop.position);
                }
            }
            for (const key of tabStops.keys) {
                if (!this.hasTabStop(parseFloat(key.toFixed(4)))) {
                    inTabs.push(tabStops.get(key));
                }
            }
        }
        inTabs = inTabs.concat(this.tabs.filter((a) => (a.position !== 0 && a.deletePosition === 0)));
        inTabs = inTabs.sort((a, b) => a.position - b.position);
        return inTabs;
    }
    getTabStopsFromListFormat() {
        if (this.listFormat.listId > -1 && this.listFormat.listLevelNumber > -1) {
            const level = this.listFormat.listLevel;
            if (level && level.paragraphFormat) {
                return level.paragraphFormat.tabs;
            }
        }
        return [];
    }
    isValidTabStop(tabs, tabStop) {
        for (let i = 0; i < tabs.length; i++) {
            if (!isNullOrUndefined(tabs[i].position) && !isNullOrUndefined(tabs[i].deletePosition) && !isNullOrUndefined(tabStop.position)) {
                if (tabStop != tabs[i] && (parseFloat(tabs[i].position.toFixed(4)) === parseFloat(tabStop.position.toFixed(4)) ||
                    (parseFloat(tabs[i].deletePosition.toFixed(4)) !== 0 && parseFloat(tabs[i].deletePosition.toFixed(4)) === parseFloat(tabStop.position.toFixed(4))))) {
                    return false;
                }
            }
        }
        return true;
    }
    hasTabStop(position) {
        for (let i = 0; i < this.tabs.length; i++) {
            if (!isNullOrUndefined(this.tabs[i].position) && !isNullOrUndefined(this.tabs[i].deletePosition)) {
                if (parseFloat(this.tabs[i].position.toFixed(4)) === position ||
                    parseFloat(this.tabs[i].deletePosition.toFixed(4)) === position) {
                    return true;
                }
            }
        }
        return false;
    }
    get leftIndent() {
        return this.getPropertyValue('leftIndent');
    }
    set leftIndent(value) {
        this.setPropertyValue('leftIndent', value);
    }
    get rightIndent() {
        return this.getPropertyValue('rightIndent');
    }
    set rightIndent(value) {
        this.setPropertyValue('rightIndent', value);
    }
    get firstLineIndent() {
        return this.getPropertyValue('firstLineIndent');
    }
    set firstLineIndent(value) {
        this.setPropertyValue('firstLineIndent', value);
    }
    get beforeSpacing() {
        return this.getPropertyValue('beforeSpacing');
    }
    set beforeSpacing(value) {
        this.setPropertyValue('beforeSpacing', value);
    }
    get afterSpacing() {
        return this.getPropertyValue('afterSpacing');
    }
    set afterSpacing(value) {
        this.setPropertyValue('afterSpacing', value);
    }
    get spaceBeforeAuto() {
        return this.getPropertyValue('spaceBeforeAuto');
    }
    set spaceBeforeAuto(value) {
        this.setPropertyValue('spaceBeforeAuto', value);
    }
    get spaceAfterAuto() {
        return this.getPropertyValue('spaceAfterAuto');
    }
    set spaceAfterAuto(value) {
        this.setPropertyValue('spaceAfterAuto', value);
    }
    get lineSpacing() {
        return this.getPropertyValue('lineSpacing');
    }
    set lineSpacing(value) {
        this.setPropertyValue('lineSpacing', value);
    }
    get lineSpacingType() {
        return this.getPropertyValue('lineSpacingType');
    }
    set lineSpacingType(value) {
        this.setPropertyValue('lineSpacingType', value);
    }
    get textAlignment() {
        let value = this.getPropertyValue('textAlignment');
        if (this.bidi) {
            if (value === 'Left') {
                value = 'Right';
            }
            else if (value === 'Right') {
                value = 'Left';
            }
        }
        return value;
    }
    set textAlignment(value) {
        this.setPropertyValue('textAlignment', value);
    }
    get keepWithNext() {
        return this.getPropertyValue('keepWithNext');
    }
    set keepWithNext(value) {
        this.setPropertyValue('keepWithNext', value);
    }
    get keepLinesTogether() {
        return this.getPropertyValue('keepLinesTogether');
    }
    set keepLinesTogether(value) {
        this.setPropertyValue('keepLinesTogether', value);
    }
    get widowControl() {
        return this.getPropertyValue('widowControl');
    }
    set widowControl(value) {
        this.setPropertyValue('widowControl', value);
    }
    get outlineLevel() {
        return this.getPropertyValue('outlineLevel');
    }
    set outlineLevel(value) {
        this.setPropertyValue('outlineLevel', value);
    }
    get bidi() {
        return this.getPropertyValue('bidi');
    }
    set bidi(value) {
        this.setPropertyValue('bidi', value);
    }
    get contextualSpacing() {
        return this.getPropertyValue('contextualSpacing');
    }
    set contextualSpacing(value) {
        this.setPropertyValue('contextualSpacing', value);
    }
    getListFormatParagraphFormat(property) {
        const paragraphFormat = this.getListPargaraphFormat(property);
        if (!isNullOrUndefined(paragraphFormat)) {
            return paragraphFormat.uniqueParagraphFormat.propertiesHash.get(WUniqueFormat.getPropertyType(WParagraphFormat.uniqueFormatType, property));
        }
        return undefined;
    }
    /**
    * @private
    */
    getListPargaraphFormat(property) {
        if (this.listFormat.hasValue('listId') && this.listFormat.listId > -1 && this.listFormat.listLevelNumber > -1) {
            const level = this.listFormat.listLevel;
            const propertyType = WUniqueFormat.getPropertyType(WParagraphFormat.uniqueFormatType, property);
            if (!isNullOrUndefined(level) && !isNullOrUndefined(level.paragraphFormat.uniqueParagraphFormat) &&
                level.paragraphFormat.uniqueParagraphFormat.propertiesHash.containsKey(propertyType)) {
                return level.paragraphFormat;
            }
            else {
                return undefined;
            }
        }
        else if (this.listFormat.hasValue('listId') && this.listFormat.listId === -1
            && (property === 'leftIndent' || property === 'firstLineIndent')) {
            const paraFormat = new WParagraphFormat();
            if (!this.hasValue('leftIndent')) {
                paraFormat.leftIndent = 0;
            }
            if (!this.hasValue('firstLineIndent')) {
                paraFormat.firstLineIndent = 0;
            }
            return paraFormat;
        }
        return undefined;
    }
    getPropertyValue(property) {
        if (!this.hasValue(property)) {
            const formatInList = this.getListFormatParagraphFormat(property);
            const hasInvalidListForIndent = this.listFormat.hasValue('listId') && this.listFormat.listId === -1
                && (property === 'leftIndent' || property === 'firstLineIndent');
            if (this.baseStyle instanceof WParagraphStyle && !hasInvalidListForIndent) {
                let currentFormat = this;
                let baseStyle = this.baseStyle;
                while (!isNullOrUndefined(baseStyle)) {
                    let listParaFormat;
                    if (!this.listFormat.hasValue('listId')) {
                        listParaFormat = baseStyle.paragraphFormat.getListPargaraphFormat(property);
                    }
                    if (baseStyle.paragraphFormat.hasValue(property)) {
                        currentFormat = baseStyle.paragraphFormat;
                        break;
                    }
                    else if (!isNullOrUndefined(listParaFormat) && listParaFormat.hasValue(property)) {
                        if (baseStyle.paragraphFormat.listFormat.listLevelNumber !== this.listFormat.listLevelNumber) {
                            const level = this.listFormat.listLevel;
                            const propertyType = WUniqueFormat.getPropertyType(WParagraphFormat.uniqueFormatType, property);
                            if (!isNullOrUndefined(level) && !isNullOrUndefined(level.paragraphFormat.uniqueParagraphFormat) &&
                                level.paragraphFormat.uniqueParagraphFormat.propertiesHash.containsKey(propertyType)) {
                                currentFormat = level.paragraphFormat;
                                break;
                            }
                        }
                        currentFormat = listParaFormat;
                        break;
                    }
                    else {
                        baseStyle = baseStyle.basedOn;
                    }
                }
                if (!isNullOrUndefined(baseStyle)) {
                    if (!isNullOrUndefined(formatInList) && this.listFormat.hasValue('listId')
                        && currentFormat.listFormat.listId === -1 && currentFormat.listFormat.listLevelNumber <= 1
                        || !isNullOrUndefined(formatInList) && this.listFormat.listId !== currentFormat.listFormat.listId
                            && currentFormat.listFormat.listLevelNumber <= 1) {
                        return formatInList;
                    }
                    const propertyType = WUniqueFormat.getPropertyType(WParagraphFormat.uniqueFormatType, property);
                    return currentFormat.uniqueParagraphFormat.propertiesHash.get(propertyType);
                }
            }
            if (!isNullOrUndefined(formatInList)) {
                return formatInList;
            }
        }
        else {
            const propertyType = WUniqueFormat.getPropertyType(WParagraphFormat.uniqueFormatType, property);
            if (!isNullOrUndefined(this.uniqueParagraphFormat) && this.uniqueParagraphFormat.propertiesHash.containsKey(propertyType)) {
                return this.uniqueParagraphFormat.propertiesHash.get(propertyType);
            }
        }
        return this.getDefaultValue(property);
    }
    getDefaultValue(property) {
        const propertyType = WUniqueFormat.getPropertyType(WParagraphFormat.uniqueFormatType, property);
        const paragraphFormatInfo = this.getDocumentParagraphFormat();
        const docParagraphFormat = paragraphFormatInfo.docParagraphFormat;
        const editorFormat = paragraphFormatInfo.editorFormat;
        if (isNullOrUndefined(docParagraphFormat) || isNullOrUndefined(docParagraphFormat.uniqueParagraphFormat)) {
            return !isNullOrUndefined(editorFormat) && editorFormat.hasOwnProperty(property) ? editorFormat[property] : WParagraphFormat.getPropertyDefaultValue(property);
        }
        const ownerBase = this.ownerBase;
        let isInsideBodyWidget = false;
        if (ownerBase && ownerBase instanceof ParagraphWidget) {
            const containerWidget = ownerBase.containerWidget;
            isInsideBodyWidget = containerWidget instanceof BlockContainer || containerWidget instanceof TextFrame || containerWidget instanceof TableCellWidget;
        }
        // Check and return property value early
        if (isInsideBodyWidget) {
            const propValue = docParagraphFormat.uniqueParagraphFormat.propertiesHash.get(propertyType);
            if (!isNullOrUndefined(propValue)) {
                return propValue;
            }
        }
        return !isNullOrUndefined(editorFormat) && editorFormat.hasOwnProperty(property) ? editorFormat[property] : WParagraphFormat.getPropertyDefaultValue(property);
    }
    /**
    * @private
    */
    getDocumentParagraphFormat() {
        let docParagraphFormat = new WParagraphFormat();
        let isPasteAction = false;
        let editorFormat;
        if (!isNullOrUndefined(this.ownerBase)) {
            let documentHelper = this.getDocumentHelperObject();
            if (!isNullOrUndefined(documentHelper)) {
                docParagraphFormat = documentHelper.paragraphFormat;
                if (!isNullOrUndefined(documentHelper.owner) && !isNullOrUndefined(documentHelper.owner.editorModule)) {
                    isPasteAction = documentHelper.owner.editorModule.isPaste;
                    editorFormat = documentHelper.owner.paragraphFormat;
                }
            }
        }
        return {
            docParagraphFormat: docParagraphFormat,
            editorFormat: editorFormat,
            isPaste: isPasteAction
        };
    }
    /**
    * @private
    */
    getDocumentHelperObject() {
        let documentHelper;
        if (this.ownerBase instanceof ParagraphWidget) {
            const bodyWidget = this.ownerBase.bodyWidget;
            if (!isNullOrUndefined(bodyWidget) && !isNullOrUndefined(bodyWidget.page) && !isNullOrUndefined(bodyWidget.page.documentHelper)) {
                documentHelper = bodyWidget.page.documentHelper;
            }
        }
        return documentHelper;
    }
    setPropertyValue(property, value, clearProperty) {
        if (isNullOrUndefined(value) || value === '' && !clearProperty) {
            value = WParagraphFormat.getPropertyDefaultValue(property);
        }
        if (isNullOrUndefined(this.uniqueParagraphFormat)
            || (isNullOrUndefined(this.uniqueParagraphFormat.propertiesHash)
                && isNullOrUndefined(this.uniqueParagraphFormat.uniqueFormatType)
                && isNullOrUndefined(this.uniqueParagraphFormat.referenceCount))) {
            this.initializeUniqueParagraphFormat(property, value);
        }
        else {
            const propertyType = WUniqueFormat.getPropertyType(this.uniqueParagraphFormat.uniqueFormatType, property);
            if (this.uniqueParagraphFormat.propertiesHash.containsKey(propertyType) &&
                this.uniqueParagraphFormat.propertiesHash.get(propertyType) === value) {
                //Do nothing, since no change in property value and return
                return;
            }
            this.uniqueParagraphFormat = WParagraphFormat.uniqueParagraphFormats.updateUniqueFormat(this.uniqueParagraphFormat, property, value);
        }
    }
    initializeUniqueParagraphFormat(property, propValue) {
        const uniqueParaFormatTemp = new Dictionary();
        this.addUniqueParaFormat('leftIndent', property, propValue, uniqueParaFormatTemp);
        this.addUniqueParaFormat('rightIndent', property, propValue, uniqueParaFormatTemp);
        this.addUniqueParaFormat('firstLineIndent', property, propValue, uniqueParaFormatTemp);
        this.addUniqueParaFormat('textAlignment', property, propValue, uniqueParaFormatTemp);
        this.addUniqueParaFormat('beforeSpacing', property, propValue, uniqueParaFormatTemp);
        this.addUniqueParaFormat('afterSpacing', property, propValue, uniqueParaFormatTemp);
        this.addUniqueParaFormat('spaceBeforeAuto', property, propValue, uniqueParaFormatTemp);
        this.addUniqueParaFormat('spaceAfterAuto', property, propValue, uniqueParaFormatTemp);
        this.addUniqueParaFormat('lineSpacing', property, propValue, uniqueParaFormatTemp);
        this.addUniqueParaFormat('lineSpacingType', property, propValue, uniqueParaFormatTemp);
        this.addUniqueParaFormat('outlineLevel', property, propValue, uniqueParaFormatTemp);
        this.addUniqueParaFormat('bidi', property, propValue, uniqueParaFormatTemp);
        this.addUniqueParaFormat('contextualSpacing', property, propValue, uniqueParaFormatTemp);
        this.addUniqueParaFormat('keepWithNext', property, propValue, uniqueParaFormatTemp);
        this.addUniqueParaFormat('keepLinesTogether', property, propValue, uniqueParaFormatTemp);
        this.addUniqueParaFormat('widowControl', property, propValue, uniqueParaFormatTemp);
        this.uniqueParagraphFormat = WParagraphFormat.uniqueParagraphFormats.addUniqueFormat(uniqueParaFormatTemp, WParagraphFormat.uniqueFormatType);
    }
    addUniqueParaFormat(property, modifiedProperty, propValue, uniqueParaFormatTemp) {
        let propertyType = WUniqueFormat.getPropertyType(WParagraphFormat.uniqueFormatType, property);
        if (property === modifiedProperty) {
            uniqueParaFormatTemp.add(propertyType, propValue);
        }
    }
    static getPropertyDefaultValue(property) {
        let value = undefined;
        switch (property) {
            case 'leftIndent':
                value = 0;
                break;
            case 'rightIndent':
                value = 0;
                break;
            case 'firstLineIndent':
                value = 0;
                break;
            case 'textAlignment':
                value = 'Left';
                break;
            case 'beforeSpacing':
                value = 0;
                break;
            case 'afterSpacing':
                value = 0;
                break;
            case 'spaceBeforeAuto':
                value = false;
                break;
            case 'spaceAfterAuto':
                value = false;
                break;
            case 'lineSpacing':
                value = 1;
                break;
            case 'lineSpacingType':
                value = 'Multiple';
                break;
            case 'styleName':
                value = 'Normal';
                break;
            case 'outlineLevel':
                value = 'BodyText';
                break;
            case 'bidi':
                value = false;
                break;
            case 'contextualSpacing':
                value = false;
                break;
            case 'keepWithNext':
                value = false;
                break;
            case 'keepLinesTogether':
                value = false;
                break;
            case 'widowControl':
                value = true;
                break;
        }
        return value;
    }
    clearIndent() {
        this.clearPropertyValue('leftIndent');
        this.clearPropertyValue('firstLineIndent');
    }
    clearPropertyValue(property) {
        this.setPropertyValue(property, undefined, true);
        if (!isNullOrUndefined(this.uniqueParagraphFormat)) {
            let key = WUniqueFormat.getPropertyType(this.uniqueParagraphFormat.uniqueFormatType, property);
            let currentUniqueParagraphFormat = new WUniqueFormat(this.uniqueParagraphFormat.uniqueFormatType);
            let value = WParagraphFormat.getPropertyDefaultValue(property);
            currentUniqueParagraphFormat.cloneItems(this.uniqueParagraphFormat, property, value, this.uniqueParagraphFormat.uniqueFormatType);
            if (currentUniqueParagraphFormat.propertiesHash.containsKey(key)) {
                currentUniqueParagraphFormat.propertiesHash.remove(key);
            }
            this.uniqueParagraphFormat = currentUniqueParagraphFormat;
        }
    }
    clearFormat() {
        if (!isNullOrUndefined(this.listFormat)) {
            this.listFormat.clearFormat();
        }
        if (!isNullOrUndefined(this.borders)) {
            this.borders.clearFormat();
        }
        if (!isNullOrUndefined(this.uniqueParagraphFormat) && this.uniqueParagraphFormat.referenceCount === 0) {
            WParagraphFormat.uniqueParagraphFormats.remove(this.uniqueParagraphFormat);
        }
        this.uniqueParagraphFormat = undefined;
        if (!isNullOrUndefined(this.getDocumentHelperObject())) {
            this.baseStyle = this.getDocumentHelperObject().styles.findByName('Normal');
        }
    }
    destroy() {
        if (!isNullOrUndefined(this.uniqueParagraphFormat)) {
            WParagraphFormat.uniqueParagraphFormats.remove(this.uniqueParagraphFormat);
        }
        this.uniqueParagraphFormat = undefined;
        if (!isNullOrUndefined(this.listFormat)) {
            this.listFormat.destroy();
        }
        this.listFormat = undefined;
        if (this.tabs && this.tabs.length > 0) {
            for (let i = 0; i < this.tabs.length; i++) {
                this.tabs[i].destroy();
            }
            this.tabs = [];
            this.tabs = undefined;
        }
        if (!isNullOrUndefined(this.borders)) {
            this.borders.destroy();
        }
        this.borders = undefined;
        this.baseStyle = undefined;
        this.ownerBase = undefined;
    }
    copyFormat(format) {
        if (!isNullOrUndefined(format)) {
            if (!isNullOrUndefined(format.uniqueParagraphFormat)) {
                this.updateUniqueParagraphFormat(format);
            }
            if (!isNullOrUndefined(format.borders)) {
                if (isNullOrUndefined(this.borders)) {
                    this.borders = new WBorders(this);
                }
                this.borders.copyFormat(format.borders);
            }
            if (!isNullOrUndefined(format.listFormat)) {
                if (isNullOrUndefined(this.listFormat)) {
                    this.listFormat = new WListFormat(this);
                }
                this.listFormat.copyFormat(format.listFormat);
            }
            if (!isNullOrUndefined(format.baseStyle)) {
                this.baseStyle = format.baseStyle;
            }
            if (!isNullOrUndefined(format.tabs)) {
                for (let i = 0; i < format.tabs.length; i++) {
                    this.tabs[i] = format.tabs[i];
                }
            }
        }
    }
    updateUniqueParagraphFormat(format) {
        let hash = undefined;
        if (this.uniqueParagraphFormat) {
            hash = this.uniqueParagraphFormat.mergeProperties(format.uniqueParagraphFormat);
            if (this.uniqueParagraphFormat.referenceCount === 0) {
                WParagraphFormat.uniqueParagraphFormats.remove(this.uniqueParagraphFormat);
                this.uniqueParagraphFormat = undefined;
            }
        }
        this.uniqueParagraphFormat = new WUniqueFormat(WParagraphFormat.uniqueFormatType);
        if (isNullOrUndefined(hash)) {
            hash = this.uniqueParagraphFormat.mergeProperties(format.uniqueParagraphFormat);
        }
        this.uniqueParagraphFormat = WParagraphFormat.uniqueParagraphFormats.addUniqueFormat(hash, WParagraphFormat.uniqueFormatType);
    }
    cloneFormat() {
        const format = new WParagraphFormat(undefined);
        format.uniqueParagraphFormat = this.uniqueParagraphFormat;
        format.baseStyle = this.baseStyle;
        if (isNullOrUndefined(this.listFormat)) {
            format.listFormat = undefined;
        }
        else {
            format.listFormat = this.listFormat.cloneListFormat();
            format.listFormat.ownerBase = format;
        }
        format.borders = isNullOrUndefined(this.borders) ? undefined : this.borders.cloneFormat();
        return format;
    }
    /**
     *
     * @private
     */
    hasValue(property) {
        if (!isNullOrUndefined(this.uniqueParagraphFormat) && !isNullOrUndefined(this.uniqueParagraphFormat.propertiesHash)) {
            const propertyType = WUniqueFormat.getPropertyType(this.uniqueParagraphFormat.uniqueFormatType, property);
            return this.uniqueParagraphFormat.propertiesHash.containsKey(propertyType);
        }
        return false;
    }
    static clear() {
        this.uniqueParagraphFormats.clear();
    }
    applyStyle(baseStyle) {
        this.baseStyle = baseStyle;
        this.listFormat.applyStyle(this.baseStyle);
    }
    getValue(property) {
        return this.hasValue(property) ? this.getPropertyValue(property) : undefined;
    }
    //This method logic is not correct for changing the style dialog. Instead of this created assign format method and used it..
    // public mergeFormat(format: WParagraphFormat, isStyle?: boolean): void {
    //     isStyle = isNullOrUndefined(isStyle) ? false : isStyle;
    //     if (isNullOrUndefined(this.getValue('leftIndent'))) {
    //         this.leftIndent = format.getValue('leftIndent') as number;
    //     }
    //     if (isNullOrUndefined(this.getValue('rightIndent'))) {
    //         this.rightIndent = format.getValue('rightIndent') as number;
    //     }
    //     if (isNullOrUndefined(this.getValue('firstLineIndent'))) {
    //         this.firstLineIndent = format.getValue('firstLineIndent') as number;
    //     }
    //     if (isNullOrUndefined(this.getValue('beforeSpacing'))) {
    //         this.beforeSpacing = format.getValue('beforeSpacing') as number;
    //     }
    //     if (isNullOrUndefined(this.getValue('afterSpacing'))) {
    //         this.afterSpacing = format.getValue('afterSpacing') as number;
    //     }
    //     if (isNullOrUndefined(this.getValue('spaceBeforeAuto'))) {
    //         this.spaceBeforeAuto = format.getValue('spaceBeforeAuto') as boolean;
    //     }
    //     if (isNullOrUndefined(this.getValue('spaceAfterAuto'))) {
    //         this.spaceAfterAuto = format.getValue('spaceAfterAuto') as boolean;
    //     }
    //     if (isNullOrUndefined(this.getValue('lineSpacing'))) {
    //         this.lineSpacing = format.getValue('lineSpacing') as number;
    //     }
    //     if (isNullOrUndefined(this.getValue('lineSpacingType'))) {
    //         this.lineSpacingType = format.getValue('lineSpacingType') as LineSpacingType;
    //     }
    //     if (isNullOrUndefined(this.getValue('textAlignment'))) {
    //         this.textAlignment = format.getValue('textAlignment') as TextAlignment;
    //     }
    //     if (isNullOrUndefined(this.getValue('outlineLevel'))) {
    //         this.outlineLevel = format.getValue('outlineLevel') as OutlineLevel;
    //     }
    //     if (!isStyle && isNullOrUndefined(this.getValue('bidi'))) {
    //         this.bidi = format.getValue('bidi') as boolean;
    //     }
    //     if (isNullOrUndefined(this.getValue('contextualSpacing'))) {
    //         this.contextualSpacing = format.getValue('contextualSpacing') as boolean;
    //     }
    //     if (isNullOrUndefined(this.getValue('keepWithNext'))) {
    //         this.keepWithNext = format.getValue('keepWithNext') as boolean;
    //     }
    //     if (isNullOrUndefined(this.getValue('keepLinesTogether'))) {
    //         this.keepLinesTogether = format.getValue('keepLinesTogether') as boolean;
    //     }
    //     if (isNullOrUndefined(this.getValue('widowControl'))) {
    //         this.widowControl = format.getValue('widowControl') as boolean;
    //     }
    //     if (isNullOrUndefined(this.listFormat)) {
    // this.listFormat.mergeFormat(format.listFormat);
    //     }
    // }
    /**
     * Assinging the value for style dialog
     * @private
     * @returns {void}
     */
    assignFormat(format, isStyle) {
        isStyle = isNullOrUndefined(isStyle) ? false : isStyle;
        if (format.hasValue('leftIndent')) {
            this.leftIndent = format.getValue('leftIndent');
        }
        if (format.hasValue('rightIndent')) {
            this.rightIndent = format.getValue('rightIndent');
        }
        if (format.hasValue('firstLineIndent')) {
            this.firstLineIndent = format.getValue('firstLineIndent');
        }
        if (format.hasValue('beforeSpacing')) {
            this.beforeSpacing = format.getValue('beforeSpacing');
        }
        if (format.hasValue('afterSpacing')) {
            this.afterSpacing = format.getValue('afterSpacing');
        }
        if (format.hasValue('spaceBeforeAuto')) {
            this.spaceBeforeAuto = format.getValue('spaceBeforeAuto');
        }
        if (format.hasValue('spaceAfterAuto')) {
            this.spaceAfterAuto = format.getValue('spaceAfterAuto');
        }
        if (format.hasValue('lineSpacing')) {
            this.lineSpacing = format.getValue('lineSpacing');
        }
        if (format.hasValue('lineSpacingType')) {
            this.lineSpacingType = format.getValue('lineSpacingType');
        }
        if (format.hasValue('textAlignment')) {
            this.textAlignment = format.getValue('textAlignment');
        }
        if (format.hasValue('outlineLevel')) {
            this.outlineLevel = format.getValue('outlineLevel');
        }
        if (!isStyle && format.hasValue('bidi')) {
            this.bidi = format.getValue('bidi');
        }
        if (format.hasValue('contextualSpacing')) {
            this.contextualSpacing = format.getValue('contextualSpacing');
        }
        if (format.hasValue('keepWithNext')) {
            this.keepWithNext = format.getValue('keepWithNext');
        }
        if (format.hasValue('keepLinesTogether')) {
            this.keepLinesTogether = format.getValue('keepLinesTogether');
        }
        if (format.hasValue('widowControl')) {
            this.widowControl = format.getValue('widowControl');
        }
    }
    /**
     * Returns true if both paragraph formats are equal
     * @private
     * @returns {boolean}
     */
    isSameFormat(format) {
        return this.baseStyle === format.baseStyle &&
            this.uniqueParagraphFormat === format.uniqueParagraphFormat;
    }
}
WParagraphFormat.uniqueParagraphFormats = new WUniqueFormats();
WParagraphFormat.uniqueFormatType = 3;
